import { Form } from 'ui/components/3-organisms/Form/Form';
import { useEffect, useRef } from 'react';
import { canLoadScript, embedHelper } from './formEmbed';

import { FormFeatureProps } from './formFeature';

export const HubSpotFeature: React.FC<FormFeatureProps> = ({ content, kicker, selectAllLabel, placeholderLabel }) => {
	const scriptRef = useRef<HTMLDivElement | null>(null);

	const { isEmbedScript, formHtmlCode, sanitizedFormHtmlCode } = embedHelper(content?.properties?.formHtmlCode);

	useEffect(() => {
		if (isEmbedScript) {
			if (canLoadScript(scriptRef, formHtmlCode)) {
				loadHubSpotScript(scriptRef, formHtmlCode);
			}
		}
	}, [formHtmlCode, scriptRef, isEmbedScript]);
	return (
		<>
			<Form
				{...content.properties}
				kicker={kicker}
				bgColor={content?.properties.color}
				showImage={content.properties.showImage}
				layoutType={content.properties.layoutType}
				displayButtonRight={content?.properties?.displayButtonRight}
				selectAllLabel={selectAllLabel}
				inputFullWidth={content?.properties?.inputFullWidth}
				placeholderLabel={placeholderLabel}
				formHtmlCode={sanitizedFormHtmlCode}
			/>
			{isEmbedScript && <div ref={scriptRef}></div>}
		</>
	);
};

// HubSpot (legacy editor) forms
const loadHubSpotScript = (scriptRef, formHtmlCode) => {
	const fragment = document.createRange().createContextualFragment(formHtmlCode);
	const scripts = fragment.querySelectorAll('script');
	const firstScript = scripts[0];
	const secondScript = scripts[1];

	if (firstScript) {
		//  initializes the form,
		const src = firstScript.getAttribute('src') || '';
		const hasHttps = src.startsWith('https://');
		firstScript.setAttribute('src', hasHttps ? src : `https:${src}`);
		firstScript.setAttribute('defer', 'true');
		if (secondScript) {
			//  creates the form in the DOM and is executed after the first script has loaded
			firstScript.addEventListener('load', () => {
				// Create form
				secondScript.setAttribute('defer', 'true');
				secondScript.setAttribute('async', 'true');
				const formContainer = scriptRef?.current?.previousSibling as HTMLDivElement | null;
				// Second script creates the form to target container
				const orttoNodes: HTMLDivElement[] = formContainer ? Array.from(formContainer?.querySelectorAll('.ortto')) : [];
				const target = orttoNodes?.length > 0 ? orttoNodes[0]?.firstChild : null;
				target?.appendChild(secondScript); // Execute form-creating script
			});
		}
		scriptRef?.current?.appendChild(firstScript); // Execute initiating script
	}
};
